import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import { getDishPrice } from 'utils/dishes';
import style from './PricesListV2.module.scss';

interface IPricesListV2Restaurant {
	id: string;
	restaurantName: Nullable<string>;
	price: Nullable<number>;
	portionPrices: Nullable<number>[];
	currencySymbol?: Nullable<string>;
}

interface IPricesListV2 {
	restaurants: IPricesListV2Restaurant[];
}

export const PricesListV2 = React.memo<IPricesListV2>(({ restaurants }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	const RestaurantsContent = () => {
		return (
			<div className={style.container} data-test="RestaurantsContent">
				{accessibleRestaurants.map((el) => {
					const { hasManyPrices, price } = getDishPrice(el);

					return (
						<div className={style.item} key={el.id}>
							<Text display="inline" translationKey={`${el.restaurantName} / `} size="xs" />
							<Text
								display="inline"
								translationNameSpace="listing"
								translationKey={hasManyPrices ? 'priceValueWithStartsFrom' : 'priceValue'}
								translationOptions={{
									price: price !== null ? `${el.currencySymbol || ''}${price}` : '-',
								}}
								size="xs"
							/>
						</div>
					);
				})}
			</div>
		);
	};

	const SinglePrice = ({ restaurant }: { restaurant: IPricesListV2Restaurant }) => {
		const { hasManyPrices, price } = getDishPrice(restaurant);

		return (
			<Text
				translationNameSpace="listing"
				translationKey={hasManyPrices ? 'priceValueWithStartsFrom' : 'priceValue'}
				translationOptions={{
					price: price !== null ? `${restaurant.currencySymbol || ''}${price}` : '-',
				}}
				withTooltip={true}
			/>
		);
	};

	return (
		<div data-test="PricesListV2">
			{accessibleRestaurants.length > 1 && (
				<Pop placement="bottomLeft" content={<RestaurantsContent />} trigger="click">
					<div className={style.wrapper}>
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			)}
			{accessibleRestaurants.length === 1 && <SinglePrice restaurant={accessibleRestaurants[0]} />}
			{accessibleRestaurants.length === 0 && <Text translationKey="-" withTooltip={true} />}
		</div>
	);
});
